export const CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  VALIDATE_TOKEN: process.env.REACT_APP_VALIDATE_TOKEN
};
